import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../redux/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faStar as faStarSolid,
} from '@fortawesome/free-solid-svg-icons'
import { SubCompetencyWithEvaluation } from '../../types/GrowthWheel'
import {
  setCurrentCompetency,
  setCurrentSubCompetency,
} from '../../redux/growthWheel.slice'
import DisplayLevelComponent from './DisplayLevelComponent'
import { RichTextView } from './RichTextView'

const AreasOfFocus = () => {
  const dispatch = useDispatch()
  const currentAreasOfFocus = useSelector(
    (state: RootState) => state.growthWheel.currentAreasOfFocus,
  )
  const userCompetenciesData = useSelector(
    (state: RootState) => state.growthWheel.userCompetenciesData,
  )

  const handleFocusSubCompetencyClick = (
    sub: SubCompetencyWithEvaluation,
  ) => {
    const parentCompetency = userCompetenciesData.find(c =>
      c.subCompetencies?.some(s => s.id === sub.id),
    )
    if (parentCompetency) {
      dispatch(setCurrentCompetency(parentCompetency))
      dispatch(setCurrentSubCompetency(sub))
    }
  }

  const focusTitle = () => {
    return currentAreasOfFocus.length > 0
      ? `Your Areas of Focus (${currentAreasOfFocus.length}/3)`
      : 'No areas of focus selected yet. Start marking sub-competencies to build your growth plan.'
  }

  return (
    <div className="gw-areas-of-focus-container">
      <div className="gw-areas-of-focus-header ">
        <FontAwesomeIcon
          className="text-warning"
          icon={faStarSolid}
          style={{ fontSize: '0.8rem' }}
        />
        <span>{focusTitle()}</span>
      </div>
      <div className="gw-areas-of-focus-list">
        {currentAreasOfFocus.map(sub => (
          <button
            key={sub.id}
            onClick={() => handleFocusSubCompetencyClick(sub)}
            className="gw-areas-of-focus-item"
          >
            <div className="gw-areas-of-focus-item-inner">
              <FontAwesomeIcon
                icon={faStarSolid}
                style={{ fontSize: '0.8rem', paddingTop: '0.2rem' }}
                className="text-warning"
              />
              <div className="gw-areas-of-focus-item-content">
                <div className="gw-areas-of-focus-item-header">
                  <h4 className="gw-areas-of-focus-item-title">{sub.name}</h4>
                  <span className="gw-areas-of-focus-item-area">
                    {sub.competencyName}
                  </span>
                </div>
                <RichTextView
                  className="gw-areas-of-focus-item-description"
                  html={sub.description}
                />
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <DisplayLevelComponent
                    label="Self"
                    level={sub.evaluation?.selfLevel ?? null}
                  />
                  <DisplayLevelComponent
                    className="gw-competency-view-level-value--guided"
                    label="Guided"
                    level={sub.evaluation?.leaderLevel ?? null}
                  />
                </div>
              </div>
              <FontAwesomeIcon
                icon={faChevronRight}
                className="gw-competency-view-chevron"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default AreasOfFocus
